@if (isOpen()) {
	<div
		class="vb-lxp-panel overflow-auto"
		#panel
		#panelDragHandle="cdkDrag"
		cdkDrag
		animate.enter="enter-animation"
		animate.leave="leave-animation"
		[ngClass]="[panelClass(), !isPinned() && !disablePin() ? 'shadow-lg resize absolute' : '']"
		[cdkDragDisabled]="isPinned() || disablePin()"
		[cdkDragConstrainPosition]="constrainPosition"
	>
		<div
			class="panel-header-container relative"
			cdkDragHandle
			[ngClass]="[panelHeaderClass(), !isPinned() && !disablePin() ? 'drag-handle' : '']"
		>
			<ng-content select="[header]"></ng-content>
			<div class="panel-header-buttons">
				<ng-content select="[before-pin-action]"></ng-content>

				@if (!disablePin()) {
					<button class="panel-action-btn" (click)="onPinClicked()">
						@if (isPinned()) {
							<i class="bi bi-pin-fill"></i>
						} @else {
							<i class="bi bi-pin-angle-fill"></i>
						}
					</button>
				}
				<button
					class="panel-action-btn close-button"
					aria-label="Close panel"
					(click)="closePanel()"
				>
					<i class="bi bi-x text-lg"></i>
				</button>
			</div>
		</div>
		<div [ngClass]="panelBodyClass()">
			<ng-content select="[body]"></ng-content>
		</div>
	</div>
}
